module.exports = __webpack_public_path__ + "img/22.911eb371.png";